export default __webpack_public_path__ + "static/media/finishDistillation.01314d00.jpg";